import { useSearchDateShortcut } from '@/hooks/useSearch'
import { secondToString } from '@/utils/date-format'
import type {
  CrudSearchItem,
  CrudSelectOption,
  CrudTableColumn
} from '@/types/crud-config'
import type { LiveAccessStatisticsRecord } from './live-access-statistics.service'

export function createLiveAccessStatisticsSearchItems(
  channels: CrudSelectOption[],
  loading: boolean
): CrudSearchItem[] {
  return [
    {
      label: '直播间',
      prop: 'channelId',
      type: 'select',
      clearable: true,
      loading,
      placeholder: '请选择直播间',
      options: channels
    },
    {
      label: '客户昵称',
      prop: 'consumerNickName',
      type: 'input',
      clearable: true,
      placeholder: '请输入客户昵称'
    },
    {
      label: '总观看时长',
      prop: 'watchTotalTime',
      type: 'select',
      clearable: true,
      placeholder: '请选择总观看时长',
      options: [
        { label: '全部', value: '' },
        { label: '≥ 5分钟', value: '300' },
        { label: '≥ 10分钟', value: '600' },
        { label: '≥ 20分钟', value: '1200' },
        { label: '≥ 25分钟', value: '1500' },
        { label: '≥ 30分钟', value: '1800' },
        { label: '≥ 40分钟', value: '2400' },
        { label: '≥ 50分钟', value: '3000' },
        { label: '≥ 60分钟', value: '3600' }
      ]
    },
    {
      label: '访问时间',
      prop: 'accessTime',
      type: 'dateTimeRange',
      valueFormat: 'YYYY-MM-DD HH:mm:ss',
      shortcuts: useSearchDateShortcut(),
      startPlaceholder: '开始时间',
      endPlaceholder: '结束时间',
      disabledDate: (date) => date.getTime() > Date.now()
    }
  ]
}

export const liveAccessStatisticsTableColumns: CrudTableColumn<LiveAccessStatisticsRecord>[] =
  [
    {
      prop: 'consumerNickName',
      label: '客户昵称',
      slot: 'consumer',
      minWidth: 160,
      align: 'left',
      showOverflowTooltip: true
    },
    {
      prop: 'channelName',
      label: '直播间名',
      minWidth: 120,
      showOverflowTooltip: true
    },
    {
      prop: 'deptName',
      label: '所属部门',
      minWidth: 100,
      showOverflowTooltip: true
    },
    {
      prop: 'empName',
      label: '所属员工',
      minWidth: 100,
      showOverflowTooltip: true
    },
    {
      prop: 'totalDuration',
      label: '访问总时长',
      minWidth: 120,
      sortable: 'custom',
      formatter: (row) => secondToString(row.totalDuration)
    }
  ]
